<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required" />

        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center">
                <label v-for="(option, index) in options"
                       :key="`label_${index}`"
                       class="radio block relative text-base sm:text-lg lg:text-2xl cursor-pointer pl-6 md:pl-10 mt-2 md:mt-6"
                       :class="[ value === index ? 'text-primary-100' : 'text-muted-500' ]">
                    <input type="radio"
                           :key="`input_${index}`"
                           :value="index"
                           v-model="value"
                           class="opacity-0 absolute"/>
                    {{ option | trans }}
                    <span class="block w-4 md:w-6 h-4 md:h-6 absolute top-0 bottom-0 left-0 m-auto select-none text-center rounded-full bg-light-100"></span>
                </label>
            </div>

            <div v-if="errorMessage" class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionHeader from './QuestionHeader';

    export default {
        components: {
            QuestionHeader
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            options: {
                type: Array,
                required: true,
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: Array
        },
        data() {
            return {
                value: null,
                errorMessage: null
            }
        },
        watch: {
            value(index) {
                const answers = [{
                    index,
                    value: this.$options.filters.trans(this.options[index])
                }];

                this.$emit('input', answers);
            }
        },
        methods: {
            validate() {
                if (this.required && this.value === null) {
                    this.errorMessage =  "This field is required!";
                    return false;
                }
                this.errorMessage = null;
                return true;
            }
        },
        mounted() {
            if (this.answer[0]) {
                this.value = this.answer[0].index;
            }
        }
    }
</script>
